import { Controller } from "@hotwired/stimulus";

// Scrolls a horizontally-overflowing element to its right edge on connect, so the
// most recent (rightmost) content is visible by default — e.g. the current hour
// at the end of the POS heartbeat timeline. Wrapped in requestAnimationFrame so
// the scroll runs after layout, once scrollWidth reflects the rendered cells.
export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.scrollLeft = this.element.scrollWidth;
    });
  }
}
